import styled from 'styled-components';
//import { baseVariables } from '@marriott/mi-ui-library';

// const { spacers } = baseVariables;
// TODO: Remove this spacers stub once we can import from mi-ui-library (DXP-30678)
const spacers = {
  spacers: {
    0: '0',
    1: '0.25rem',
    2: '0.5rem',
    3: '1rem',
    4: '1.5rem',
    5: '2rem',
  },
};

export const Wrapper = styled.div`
  display: inline-flex;
  align-items: center;
  gap: ${spacers?.spacers?.[1]};
`;
